<template>
  <div>
    <template v-if="spinnerEmployeeSpecificQuestion == true">
      <ob-spinner></ob-spinner>
    </template>
    <!-- main Top Section Starts -->
    <div v-else>

      <template>
        <div class="row m0">
          <div class="EmployeeSQ-details clearfix">
            <div class="col-md-2" v-if="selectCandidateData.data.length > 1">
              <div class="form-group m0">
                <label>Select Organization</label>
                <ob-select2 :options="selectCandidateData" v-model="questionCategorydroplist" @input="organizationChange"></ob-select2>
                <p style="color: #D60000;position: absolute; font-size: 10px;" v-if="questionCategorydroplist ==''">Please select a organization to see questions</p>
              </div>
            </div>
            <div  v-if="questionCategorydroplist !=''" class="clearfix">
              <div class="col-md-2">
                <div class="form-group m0">
                  <label>Organization Name</label>
                  <p class="name-txt">{{dataBasedOnSelectCandidate.OrgName == "" ? 'N/A' :dataBasedOnSelectCandidate.OrgName }}</p>
                </div>
              </div>
              <div class="col-md-2" >
                <div class="form-group m0">
                  <label>Organization Website</label>
                   <p class="name-txt" v-html="dataBasedOnSelectCandidate.WebSite == '' ? 'N/A' : `<a href='${dataBasedOnSelectCandidate.WebSite}' title='${dataBasedOnSelectCandidate.WebSite}' target='_blank'>${dataBasedOnSelectCandidate.WebSite}</a>`"></p>
                </div>
              </div>
              <div class="col-md-4" >
                <div class="form-group m0">
                  <label>Organization Address</label>
                  <p class="name-txt">{{dataBasedOnSelectCandidate.Address =="" ? 'N/A':dataBasedOnSelectCandidate.Address }}</p>
                </div>
              </div>
              <div class="col-md-2 footer-specfic">
                <div class="form-group m0">
                  <ob-button type="secondary" :disabled="questionCategorydroplist ==''" @click="viewProfileSummaryPopupClick">View Profile Summary</ob-button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </template>
      <view-profile-summary-pooup :openviewProfileSummaryPopUp.sync="toOpenviewProfileSummaryPopUp" :toSummaryIdDetails ="summaryIdDetails"></view-profile-summary-pooup>

       <div v-if="questionCategorydroplist !=''" style="height: calc(100% - 83px)">
        <template v-if="spinnerEmployeeQuestionselected == true">
          <ob-spinner></ob-spinner>
        </template>
        <template v-else="">
          <div v-if="QuestionList && QuestionList.length > 0" class="employee-specific-list">
            <list :QuestionCategoryList="QuestionCategoryList" :QuestionList="QuestionList" :OrgId="OrgId" @questionupdated="reloadQuestions"></list>
          </div>
          <div class="MT-Content-table" v-else="">
            <div class="MT-Content" v-if="IsFilterApplied">The questions you searched for is not available in database</div>
            <div class="MT-Content" v-else="">No FDNS data</div>
          </div>
        </template>
      </div>
      <!-- main Top Section ends -->
    </div>
  </div>
</template>
<script>
import mixins from "../mixins.js";

import List from "../QA/List.vue";
import ViewProfileSummaryPopUp from "../FDNS-PopUp/ViewProfileSummaryPopup.vue";
import {
  required,
  requiredIf,
  maxLength,
  alpha,
  email,
  minValue
} from "vuelidate/lib/validators";
export default {
  mixins: [mixins],
  data() {
    return {
      OrgId: "",
      questionCategorydroplist: "",
      dataBasedOnSelectCandidate: "",
      toOpenviewProfileSummaryPopUp: false,
      spinnerEmployeeSpecificQuestion: true,
      changeSelectCandidateData: "",
      spinnerEmployeeQuestionselected: true,
      summaryIdDetails: "",
      toFdns: {
        name: "FDNS",
        query: this.$route.query
      },
      openModal: false,
      questionCategoryOption: {
        data: [
          {
            id: "Organization",
            text: "Organization"
          },
          {
            id: "Candidate",
            text: "Candidate"
          },
          {
            id: "Signatory Authority",
            text: "Signatory Authority"
          },
          {
            id: "Supervisor",
            text: "Supervisor"
          },
          {
            id: "Work Location",
            text: "Work Location"
          },
          {
            id: "Pay Information",
            text: "Pay Information"
          }
        ],
        placeholder: "Question Category"
      },

      questionTypeOptions: {
        data: [
          {
            id: "Employer Questions",
            text: "Organization"
          },
          {
            id: "Employee Generic Questions",
            text: "Employee Generic Questions"
          },
          {
            id: "Employee Specific Questions",
            text: "Employee Specific Questions"
          },
          {
            id: "FDNS Visit History",
            text: "FDNS Visit History"
          }
        ],
        placeholder: "Question Type"
      },
      selectCandidateData: {
        placeholder: {
          id: "-1",
          text: "Select Candidate"
        },
        data: []
      },
      employeeNameOption: {
        data: []
      },
      questionTypeData: "",
      addQuestionData: {
        QuestionTitle: "",
        Answer: "",
        questionCategory: "",
        questionType: ""
      },
      validate: false,
      isValid: true,
    };
  },
  validations() {
    return {
      addQuestionData: {
        QuestionTitle: {
          required
        },
        Answer: {
          required
        },
        questionCategory: {
          required
        },
        questionType: {
          required
        },
        employeeName: {
          requiredIf: requiredIf(() => {
            if (this.addQuestionData.questionType == "EmployeeSpecific") {
              return true;
            } else {
              return false;
            }
          })
        }
      }
    };
  },
  computed: {
    QuestionCategoryList() {
      return this.$store.getters.getFDNSQuestionCategoryList;
    },
    QuestionList() {
      return this.$store.getters.getFDNSQuestionList;
    },
    IsFilterApplied() {
      return this.$store.getters.getFDNSShowClearFilter;
    }
  },
  created() {
    // update placeholder content
    if (this.isConsultant) {
      this.selectCandidateData.placeholder.text = "Select Organization";
    }
    this.resetFDNSStore();
    this.$store.commit("updateFDNSResetSearchFilter");
    this.$store.commit("updateFDNSSearchFilterField", {
      field: "QuestionType",
      value: "EmployeeSpecific"
    });
    this.init();
  },
  components: {
    list: List,
    "view-profile-summary-pooup": ViewProfileSummaryPopUp
  },
  methods: {
    reloadQuestions() {
      // if (this.isHRManager) {
      //   if (
      //     this.questionCategorydroplist &&
      //     this.questionCategorydroplist != ""
      //   ) {
      //     this.questionCategorydropChange(this.questionCategorydroplist);
      //   }
      // } else
      if (this.isConsultant) {
        if (
          this.questionCategorydroplist &&
          this.questionCategorydroplist != ""
        ) {
          this.organizationChange(this.questionCategorydroplist);
        }
      }
    },
    viewProfileSummaryPopupClick() {

      this.toOpenviewProfileSummaryPopUp = true;
      this.summaryIdDetails = this.dataBasedOnSelectCandidate.OrgId;
      // if (this.isHRManager) {
      //   this.summaryIdDetails = this.dataBasedOnSelectCandidate.ConsultantId;
      // } else {
      //   this.summaryIdDetails = this.dataBasedOnSelectCandidate.OrgId;
      // }
    },
    reset() {
      //reset
      this.questionCategorydroplist = "";
      this.dataBasedOnSelectCandidate = "";
    },
    init() {
      this.reset();
      this.makeAjaxCalls();
    },

    makeAjaxCalls() {
      this.spinnerEmployeeSpecificQuestion = true;
      // if (this.isHRManager) {
      //   this.initHR();
      // } else
      if (this.isConsultant) {
        this.initJobSeeker();
      } else {
        this.$message({
          type: "error",
          message: "Error"
        });
      }
    },

    initHR() {
      this.spinnerEmployeeSpecificQuestion = false;
      ajax.get(`/OnBoarding/GetEmployeeList`, {}, res => {
        if (res.data.State == true) {
          this.spinnerEmployeeSpecificQuestion = false;
          this.changeSelectCandidateData = res.data.resultList;
          this.selectCandidateData.data = __.map(res.data.resultList, t => {
            return {
              id: t.ConsultantId,
              text: t.ConsultantName,
              detailedData: t
            };
          });

          // load the first candidate questions by default
          if (res.data.resultList.length > 0) {
            let firstConsultantId = res.data.resultList[0].ConsultantId;

            this.questionCategorydroplist = firstConsultantId;
            this.questionCategorydropChange(firstConsultantId);
          }
        } else {
          //this.ESSEnableDisable(res)
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    },

    initJobSeeker() {
      ajax.get(`/OnBoarding/GetAllMyEmployerList`, {}, res => {
        if (res.data.State == true) {
          this.spinnerEmployeeSpecificQuestion = false;
          this.changeSelectCandidateData = res.data.resultList;
          this.selectCandidateData.data = __.map(res.data.resultList, t => {
            return {
              id: t.OrgId,
              text: t.OrgName,
              detailedData: t
            };
          });

          // load the first organization questions by default
          if (res.data.resultList.length > 0) {
            let firstOrgId = res.data.resultList[0].OrgId;

            this.questionCategorydroplist = firstOrgId;
            this.organizationChange(firstOrgId);
          }
        } else {
          this.ESSEnableDisable(res)
          this.$message({
            type: "error",
            message: res.data.Message
          });
        }
      });
    },

    organizationChange(i) {
      this.OrgId = i;
      this.changeSelectCandidateData.forEach(o => {
        if (o.OrgId == i) {
          this.dataBasedOnSelectCandidate = o;
          //this.spinnerEmployeeQuestionselected = true;

          this.$store.commit("updateFDNSConsultantId", this.loggedInUserObj.consultantId);
          this.$store.commit("updateFDNSEmpOrgId", i);

          ajax.get(
            `/FDNSAudit/GetEmployeeSpecificQuestions?consultantId=${this.loggedInUserObj.consultantId}&empOrgId=${this.loggedInUserObj.orgId}&isESS=true`,
            {},
            res => {
              if (res.data.State == true) {
                this.$store.commit(
                  "updateFDNSQuestionList",
                  res.data.resultList
                );
                this.spinnerEmployeeQuestionselected = false;
              } else {
                this.ESSEnableDisable(res)
                this.$message({
                  type: "error",
                  message: res.data.Message
                });
                this.spinnerEmployeeQuestionselected = false;
              }
            }
          );
        }
      });
    },
    questionCategorydropChange(i) {
      this.$store.commit("updateFDNSResetSearchFilter");
      this.$store.commit("updateFDNSSearchFilterField", {
        field: "QuestionType",
        value: "EmployeeSpecific"
      });
      this.OrgId = this.loggedInUserObj.orgId;
      this.changeSelectCandidateData.forEach(o => {
        if (o.ConsultantId == i) {
          this.dataBasedOnSelectCandidate = o;
          //this.spinnerEmployeeQuestionselected = true;

          this.$store.commit("updateFDNSConsultantId", i);
          this.$store.commit("updateFDNSEmpOrgId", this.loggedInUserObj.orgId);

          ajax.get(
            `/FDNSAudit/GetEmployeeSpecificQuestions?consultantId=${i}&empOrgId=${
              this.loggedInUserObj.orgId
            }&isESS=true`,
            {},
            res => {
              if (res.data.State == true) {
                this.$store.commit(
                  "updateFDNSQuestionList",
                  res.data.resultList
                );
                this.spinnerEmployeeQuestionselected = false;
              } else {
                this.ESSEnableDisable(res)
                this.$message({
                  type: "error",
                  message: res.data.Message
                });
                this.spinnerEmployeeQuestionselected = false;
              }
            }
          );
        }
      });
    },

    getQuestionCategoryDetails(questionCategoryValues, key) {
      if (questionCategoryValues != "" && questionCategoryValues[key] != null) {
        let docData = questionCategoryValues;
        let keyData = key;
        return docData[keyData];
      }

      return "N/A";
    }
  }
};
</script>
<style scoped="" lang="scss">
//  header section START
.header-label {
  color: #143361;
  font-weight: 700;
  margin: 0px;
  font-size: 17px;
  line-height: 31px;
}

.left-section-search {
  width: 25%;
  float: left;
}

.right-section-search {
  width: 75%;
  display: inline-block;
  text-align: right;
}

.search-field-bar {
  width: 30%;
  display: inline-block;
}

.search-btn-field {
  margin-left: -6px;
  margin-bottom: 2px;
} //  header section END
//Main Section start
.answer-txt {
  display: block;
  margin: 10px 0;
  width: 100%;
  margin-left: 15px;
}

.manual-txt {
  display: inline;
  color: #b3b2bb;
  font-size: 13px;
  font-weight: 600;
}

/* Change color of dropdown links on hover */
.heading-txt {
  padding: 15px 15px 15px 22px;
  border-bottom: 1px solid #4a90e3;
  position: -webkit-sticky;
  position: sticky;
  top: -15px;
  background: #fff;
  z-index: 1;
  p {
    color: #4a90e3;
    font-size: 16px;
    font-weight: 600;
  }
}

.Fdns-audit-fluid {
  padding: 0px 20px 0 20px;
}

.fdnsaudit-container {
  background: #fff;
}

.fdns-footer {
  padding: 0 0 20px 0;
  text-align: center;
} // TABS STARTS
.fdns-header_tabs {
  margin: 20px 0 0 0;
  ul {
    padding: 0;
    width: 60%;
    display: inline-block;
    li {
      list-style: none;
      display: inline;
      padding: 7px 0px 7px 20px;
      a {
        font-size: 16px;
        font-weight: 600;
        color: #b0b2b5;
      }
    }
    li.active {
      border-bottom: 3px solid #2d4972;
      a {
        color: #143361;
      }
    }
  }
}

.fdns-header-tabs-right {
  text-align: right;
  width: 39%;
  display: inline-block;
} // TABS ENDS
//Add Question popup start
textarea {
  background: #fff;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  width: 100%;
  height: 90px;
  resize: none;
  color: #555555;
}

.modal-pad {
  padding: 35px;
}
.questiontypebase {
  margin-top: 15px;
}
.ob-margin-no {
  margin-top: 15px;
}
.name-txt {
  color: #30303f;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.EmployeeSQ-details {
  background: #fff;
  padding: 15px 0 15px 0;
}
.MT-Content {
  margin-top: 8%;
  text-align: center;
  width: 100%;
  height: 100%;
  display: block;
  vertical-align: middle;
  font-weight: 600;
}
.employee-specific-list {
  .fixed-dropdown {
    position: fixed;
    right: 15px;
    top: 260px;
    z-index: 2;
  }
}
.label-data-text {
  font-size: 12px;
}
.newOrg {
  text-align: center;
  padding-top: 180px;
}
//Add Question popup end
</style>
<style lang="scss">
.employee-specific-list {
  .fixed-dropdown {
    position: fixed;
    right: 37px !important;
    top: 260px !important;
    z-index: 2;
  }
}
.footer-specfic {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNSTabs/EmployeeSpecificQuestions.vue